module.exports = __webpack_public_path__ + "media/images/login-bg-cc48193141a870b62e7f2a2a91afbeb7.png";